import React from 'react';
import '../styles/Footer.scss';
import logo from '../assets/lonavalley-logo.png';
import fb from '../assets/fb.png';
import insta from '../assets/instagram.png';


export default function Footer() {
    return (
        <footer className="site-footer">
            <div className="container">
                <div className="foot-brand">
                    <img src={logo} alt="Lonavalley logo" />
                    <div>
                        <strong>Lonavalley @Lonavala Annex</strong>
                        <small>Premium Resort NA Plots near Lonavala</small>
                    </div>
                </div>


                <nav className="foot-links">
                    <a href="#highlights">Highlights</a>
                    <a href="#location">Location</a>
                    <a href="#amenities">Amenities</a>
                    <a href="#faq">FAQ?</a>
                    <a href="#contact">Contact</a>
                </nav>


                <div className="socials">
                    <a href="https://www.instagram.com/samriddhigroupofficial?igsh=c3dhYXFmOGJjYWlp" aria-label="Instagram" target='_blank'>
                    
                    <img src={insta} alt='samriddhi group instagram'></img>
                    
                    </a>
                    <a href="https://www.facebook.com/samriddhigroup24/" aria-label="Facebook" target='_blank'>
                      <img src={fb} alt='samriddhi group facebook'></img>
                    </a>
                </div>
            </div>
            <div className="copyright">© {new Date().getFullYear()} Samriddhi Group. All rights reserved.</div>
        </footer>
    );
}